import { normalize } from 'normalizr';

import { notify } from 'utils/reduxUtils';

import * as entities from './entities';

export const types = {
  ACTION_MODAL_CLOSE: 'purchasedComponents/ACTION_MODAL_CLOSE',
  ACTION_MODAL_OPEN: 'purchasedComponents/ACTION_MODAL_OPEN',
  CUSTOM_COLUMNS_CREATE_ERROR:
    'purchasedComponents/CUSTOM_COLUMNS_CREATE_ERROR',
  CUSTOM_COLUMNS_CREATE_REQUEST:
    'purchasedComponents/CUSTOM_COLUMNS_CREATE_REQUEST',
  CUSTOM_COLUMNS_CREATE_SUCCESS:
    'purchasedComponents/CUSTOM_COLUMNS_CREATE_SUCCESS',
  CUSTOM_COLUMNS_DELETE_ERROR:
    'purchasedComponents/CUSTOM_COLUMNS_DELETE_ERROR',
  CUSTOM_COLUMNS_DELETE_REQUEST:
    'purchasedComponents/CUSTOM_COLUMNS_DELETE_REQUEST',
  CUSTOM_COLUMNS_DELETE_SUCCESS:
    'purchasedComponents/CUSTOM_COLUMNS_DELETE_SUCCESS',
  CUSTOM_COLUMNS_DRAWER_CLOSE:
    'purchasedComponents/CUSTOM_COLUMNS_DRAWER_CLOSE',
  CUSTOM_COLUMNS_DRAWER_OPEN: 'purchasedComponents/CUSTOM_COLUMNS_DRAWER_OPEN',
  CUSTOM_COLUMNS_RECEIVE: 'purchasedComponents/CUSTOM_COLUMNS_RECEIVE',
  CUSTOM_COLUMNS_REORDER_FLOW:
    'purchasedComponents/CUSTOM_COLUMNS_REORDER_FLOW',
  CUSTOM_COLUMNS_REORDER_REQUEST:
    'purchasedComponents/CUSTOM_COLUMNS_REORDER_REQUEST',
  CUSTOM_COLUMNS_REORDER_SUCCESS:
    'purchasedComponents/CUSTOM_COLUMNS_REORDER_SUCCESS',
  CUSTOM_COLUMNS_UPDATE_ERROR:
    'purchasedComponents/CUSTOM_COLUMNS_UPDATE_ERROR',
  CUSTOM_COLUMNS_UPDATE_REQUEST:
    'purchasedComponents/CUSTOM_COLUMNS_UPDATE_REQUEST',
  CUSTOM_COLUMNS_UPDATE_SUCCESS:
    'purchasedComponents/CUSTOM_COLUMNS_UPDATE_SUCCESS',
  LIST_PAGE_MARK_TABLE_DIRTY: 'purchasedComponents/LIST_PAGE_MARK_TABLE_DIRTY',
  LIST_PAGE_PAGINATE: 'purchasedComponents/LIST_PAGE_PAGINATE',
  LIST_PAGE_RECEIVE_TABLE_DATA:
    'purchasedComponents/LIST_PAGE_RECEIVE_TABLE_DATA',
  LIST_PAGE_SEARCH: 'purchasedComponents/LIST_PAGE_SEARCH',
  LIST_PAGE_SORT: 'purchasedComponents/LIST_PAGE_SORT',
  PURCHASED_COMPONENT_CREATE_SUCCESS:
    'purchasedComponents/PURCHASED_COMPONENT_CREATE_SUCCESS',
  PURCHASED_COMPONENT_DELETE_SUCCESS:
    'purchasedComponents/PURCHASED_COMPONENTS_DELETE_SUCCESS',
  PURCHASED_COMPONENT_UPDATE_SUCCESS:
    'purchasedComponents/PURCHASED_COMPONENT_UPDATE_SUCCESS',
  PURCHASED_COMPONENTS_LIST_ERROR:
    'purchasedComponents/PURCHASED_COMPONENTS_LIST_ERROR',
  PURCHASED_COMPONENTS_LIST_REQUEST:
    'purchasedComponents/PURCHASED_COMPONENTS_LIST_REQUEST',
  PURCHASED_COMPONENTS_LIST_SUCCESS:
    'purchasedComponents/PURCHASED_COMPONENTS_LIST_SUCCESS',
  UPLOAD_PURCHASED_COMPONENTS_ERROR:
    'purchasedComponents/UPLOAD_PURCHASED_COMPONENTS_ERROR',
  UPLOAD_PURCHASED_COMPONENTS_REQUEST:
    'purchasedComponents/UPLOAD_PURCHASED_COMPONENTS_REQUEST',
  UPLOAD_PURCHASED_COMPONENTS_SUCCESS:
    'purchasedComponents/UPLOAD_PURCHASED_COMPONENTS_SUCCESS',
};

export const actionModal = {
  open: ({ customColumnId, mode }) => ({
    type: types.ACTION_MODAL_OPEN,
    payload: { customColumnId, mode },
  }),
  close: () => ({
    type: types.ACTION_MODAL_CLOSE,
  }),
};

export const listPage = {
  markTableDirty: () => ({
    type: types.LIST_PAGE_MARK_TABLE_DIRTY,
  }),
  paginate: ({ pageNumber, pageSize }) => ({
    type: types.LIST_PAGE_PAGINATE,
    payload: { pageNumber, pageSize },
  }),
  receiveTableData: ({ tableData }) => ({
    type: types.LIST_PAGE_RECEIVE_TABLE_DATA,
    payload: { tableData },
  }),
  search: ({ searchString }) => ({
    type: types.LIST_PAGE_SEARCH,
    payload: { searchString },
  }),
  sort: ({ sortString }) => ({
    type: types.LIST_PAGE_SORT,
    payload: { sortString },
  }),
};

export const purchasedComponentsList = {
  error: notify(
    (error) => ({
      type: types.PURCHASED_COMPONENTS_LIST_ERROR,
      payload: error,
    }),
    'Failed to fetch purchased components',
  ),
  request: () => ({
    type: types.PURCHASED_COMPONENTS_LIST_REQUEST,
  }),
  success: (payload) => ({
    type: types.PURCHASED_COMPONENTS_LIST_SUCCESS,
    payload: {
      ...normalize(payload.results, [entities.purchasedComponentSchema]),
      count: payload.count,
    },
  }),
};

export const purchasedComponentCreate = {
  success: ({ purchasedComponent }) => ({
    type: types.PURCHASED_COMPONENT_CREATE_SUCCESS,
    payload: {
      ...normalize(purchasedComponent, entities.purchasedComponentSchema),
    },
  }),
};

export const purchasedComponentDelete = {
  success: ({ purchasedComponentId }) => ({
    type: types.PURCHASED_COMPONENT_DELETE_SUCCESS,
    payload: { purchasedComponentId },
  }),
};

export const purchasedComponentUpdate = {
  success: ({ purchasedComponent }) => ({
    type: types.PURCHASED_COMPONENT_UPDATE_SUCCESS,
    payload: {
      ...normalize(purchasedComponent, entities.purchasedComponentSchema),
    },
  }),
};

export const uploadPurchasedComponents = {
  request: (data) => ({
    type: types.UPLOAD_PURCHASED_COMPONENTS_REQUEST,
    payload: data,
  }),
  success: notify(
    () => ({
      type: types.UPLOAD_PURCHASED_COMPONENTS_SUCCESS,
    }),
    'File uploaded successfully',
  ),
  error: notify(
    (error) => ({
      type: types.UPLOAD_PURCHASED_COMPONENTS_ERROR,
      payload: error,
    }),
    'Failed to upload',
  ),
};

export const customColumnsReceive = (payload) => ({
  type: types.CUSTOM_COLUMNS_RECEIVE,
  payload: { ...normalize(payload, [entities.customColumnSchema]) },
});

export const customColumnsDrawer = {
  open: () => ({
    type: types.CUSTOM_COLUMNS_DRAWER_OPEN,
  }),
  close: () => ({
    type: types.CUSTOM_COLUMNS_DRAWER_CLOSE,
  }),
};

export const customColumnsCreate = {
  error: notify(
    (error) => ({
      type: types.CUSTOM_COLUMNS_CREATE_ERROR,
      payload: error,
    }),
    'Failed to create column',
  ),
  request: ({ data }) => ({
    type: types.CUSTOM_COLUMNS_CREATE_REQUEST,
    payload: { data },
  }),
  success: ({ customColumn }) => ({
    type: types.CUSTOM_COLUMNS_CREATE_SUCCESS,
    payload: {
      ...normalize(customColumn, entities.customColumnSchema),
    },
  }),
};

export const customColumnsReorder = {
  flow: ({ index }) => ({
    type: types.CUSTOM_COLUMNS_REORDER_FLOW,
    payload: { index },
  }),
  request: ({ oldIndex, newIndex }) => ({
    type: types.CUSTOM_COLUMNS_REORDER_REQUEST,
    payload: { oldIndex, newIndex },
  }),
  success: ({ customColumns }) => ({
    type: types.CUSTOM_COLUMNS_REORDER_SUCCESS,
    payload: {
      ...normalize(customColumns, [entities.customColumnSchema]),
    },
  }),
};

export const customColumnsUpdate = {
  error: notify(
    (error) => ({
      type: types.CUSTOM_COLUMNS_UPDATE_ERROR,
      payload: error,
    }),
    'Failed to update column',
  ),
  request: ({ customColumnId, data }) => ({
    type: types.CUSTOM_COLUMNS_UPDATE_REQUEST,
    payload: { customColumnId, data },
  }),
  success: ({ customColumn }) => ({
    type: types.CUSTOM_COLUMNS_UPDATE_SUCCESS,
    payload: {
      ...normalize(customColumn, entities.customColumnSchema),
    },
  }),
};

export const customColumnsDelete = {
  error: notify(
    (error) => ({
      type: types.CUSTOM_COLUMNS_DELETE_ERROR,
      payload: error,
    }),
    'Failed to delete column',
  ),
  request: ({ customColumnId }) => ({
    type: types.CUSTOM_COLUMNS_DELETE_REQUEST,
    payload: { customColumnId },
  }),
  success: ({ customColumnId }) => ({
    type: types.CUSTOM_COLUMNS_DELETE_SUCCESS,
    payload: { customColumnId },
  }),
};
